import axios from "axios";

export const loadAllRelatedContactAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?limit=${payload.pageSize}&page=${
        payload.currentPage
      }&entityId=${payload.entityId}&entityType=${
        payload.entityType
      }&countries=[${payload.countryId}]&orderBy=${
        payload.sort ? payload.sort.dir : "desc"
      }&status=${payload.status}&platformUser=${
        payload.platformUser
      }&orderColumn=${payload.sort ? payload.sort.column : "id"}&search=${
        payload.search ?? ""
      }&dependancies=${payload?.dependancies}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const loadSingleRelatedContactAPI = (payload) => {
  return axios
    .get(`/relatedContacts/${payload.relatedContactId}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.data);
};
